import React from 'react'
import { Col, Container, Row } from 'reactstrap'

import Navbar from '../pages/Navbar/index/Index'

const PaymentLayout = ({ children }) => (
    <React.Fragment>
        <Container fluid className="d-flex flex-column">
            <Row className="vh-100">
                <Navbar isPayment />
                <Col sm="12" className="h-100 scrollable-col">
                    {children}
                </Col>
            </Row>
        </Container>
    </React.Fragment>
)

export default PaymentLayout
